<template>

  <div class="tr" style="font-weight: bold;font-size: 14px;text-indent: 10px;">
    <span style="margin: 4px 0"># {{element.label}}</span>
  </div>

</template>

<script>


export default {
  components: {},
  props: {
    form:{
      type: Object,
    },
    data:{
      type:Object,
    },
    element:{
      type:Object
    },
    parent:{
      type:Object
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {}
  },
  created() {
  }
}

</script>

<style scoped lang="scss">

</style>